// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"alertForm_wrapper_3TL4wgV","content":"alertForm_content_gtSDZaQ"};